import { Injectable } from '@angular/core';
import {HttpClient, HttpHeaders} from "@angular/common/http";
import {AuthenticationService} from "../Login/_services/authentication.service";
import {ApiPathsService} from "../api-paths.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {Blocco} from "./_Models/blocco";
import {ClassicType} from "../shared/models/ClassicType";

@Injectable({
  providedIn: 'root'
})
export class ApiRestService {
  constructor(
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private apiPaths: ApiPathsService,
  ) { }
  options() {
    return {headers: new HttpHeaders({'Content-Type': 'application/json', Authorization: `Bearer ${this.authenticationService?.currentUserValue?.access_token}`,})};
  }
  BlocchiList(value): Observable<Blocco[]> {
    return this.http.post<Blocco[]>(
      `${this.apiPaths.getBaseAPI()}/stampa/blocchi/list`,
      JSON.stringify(value),
      this.options()).pipe(map((data) => {
      return data;
    }));
  }
  ContenutoList(value): Observable<any>{
    return this.http.post<any>(
      `${this.apiPaths.getBaseAPI()}/stampa/blocchi/contenuto/list`,
      JSON.stringify(value),
      this.options()).pipe(map((data) => {
      return data;
    }));
  }
  GetContenuto(value): Observable<string>{
    return this.http.post<any>(
      `${this.apiPaths.getBaseAPI()}/stampa/blocchi/contenuto/get`,
      JSON.stringify(value),
      this.options()).pipe(map((data) => {
      return data;
    }));
  }
  ContenutoAdd(value): Observable<any>{
    return this.http.post<any>(
      `${this.apiPaths.getBaseAPI()}/stampa/blocchi/contenuto/add`,
      JSON.stringify(value),
      this.options()).pipe(map((data) => {
      return data;
    }));
  }
  ContenutoUpdate(value): Observable<any>{
    return this.http.post<any>(
      `${this.apiPaths.getBaseAPI()}/stampa/blocchi/contenuto/update`,
      JSON.stringify(value),
      this.options()).pipe(map((data) => {
      return data;
    }));
  }
  ContenutoDelete(value): Observable<any>{
    return this.http.post<any>(
      `${this.apiPaths.getBaseAPI()}/stampa/blocchi/contenuto/delete`,
      JSON.stringify(value),
      this.options()).pipe(map((data) => {
      return data;
    }));
  }

  GetBlocco(value: Blocco) : Observable<Blocco>{
    return this.http.post<any>(
      `${this.apiPaths.getBaseAPI()}/stampa/blocchi/get`,
      JSON.stringify(value),
      this.options()).pipe(map((data) => {
      return data;
    }));
  }
  BlocchiAdd(value): Observable<Blocco> {
    return this.http.post<Blocco>(
      `${this.apiPaths.getBaseAPI()}/stampa/blocchi/add`,
      JSON.stringify(value),
      this.options()).pipe(map((data) => {
      return data;
    }));
  }
  BlocchiUpdate(value): Observable<any> {
    return this.http.post<any>(
      `${this.apiPaths.getBaseAPI()}/stampa/blocchi/update`,
      JSON.stringify(value),
      this.options()).pipe(map((data) => {
      return data;
    }));
  }
  BlocchiDelete(value): Observable<any> {
    return this.http.post<any>(
      `${this.apiPaths.getBaseAPI()}/stampa/blocchi/delete`,
      JSON.stringify(value),
      this.options()).pipe(map((data) => {
      return data;
    }));
  }
  SezioniList() : Observable<ClassicType[]>{
    return this.http.get<ClassicType[]>(
      `${this.apiPaths.getBaseAPI()}/stampa/blocchi/sezioni`,
      this.options()).pipe(map((data) => {
      return data;
    }));
  }
}
